import { gql } from "@outschool/ui-apollo";

// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { ListingCardFragment } from "./fragments";

export type SimilarityAlgorithms =
  | "popular"
  | "popularElasticsearch"
  | "popularMBA"
  | "tfidf";

export type SimilarityConfig = {
  operationName: string;
  query: any; // DocumentNode;
};

export const SIMILARITY_ALGORITHMS: {
  [key in SimilarityAlgorithms]: SimilarityConfig;
} = {
  popular: {
    operationName: "SimilarListings",
    query: gql`
      query SimilarListings(
        $activityUid: ID!
        $skipRating: Boolean!
        $withRecentReviews: Boolean!
      ) {
        listing(activityUid: $activityUid) {
          similarListings {
            popular {
              ...ListingCard_listing
            }
          }
        }
      }
      ${ListingCardFragment}
    `,
  },
  popularElasticsearch: {
    operationName: "SimilarListingsElasticsearch",
    query: gql`
      query SimilarListingsElasticsearch(
        $activityUid: ID!
        $skipRating: Boolean!
        $withRecentReviews: Boolean!
      ) {
        listing(activityUid: $activityUid) {
          similarListings {
            popularElasticsearch {
              ...ListingCard_listing
            }
          }
        }
      }
      ${ListingCardFragment}
    `,
  },
  popularMBA: {
    operationName: "SimilarListingsMBA",
    query: gql`
      query SimilarListingsMBA(
        $activityUid: ID!
        $skipRating: Boolean!
        $withRecentReviews: Boolean!
      ) {
        listing(activityUid: $activityUid) {
          similarListings {
            popularMBA {
              ...ListingCard_listing
            }
          }
        }
      }
      ${ListingCardFragment}
    `,
  },
  tfidf: {
    operationName: "SimilarListingsByTfIdf",
    query: gql`
      query SimilarListingsByTfIdf(
        $activityUid: ID!
        $skipRating: Boolean!
        $limit: Int
        $withRecentReviews: Boolean!
      ) {
        listing(activityUid: $activityUid) {
          similarListings {
            tfidf(limit: $limit) {
              ...ListingCard_listing
            }
          }
        }
      }
      ${ListingCardFragment}
    `,
  },
};
